import {Button, DatePicker, Form, Input, Modal, message} from "antd";
import TextArea from "antd/lib/input/TextArea";
import React, {useEffect, useState} from "react";
import api from "../../api";
import dayjs from "dayjs";
import {useTranslations} from "../../lang";
import {submitValidatedForm} from "../../formValidation";

export default function TaskModal({open, onCancel, onSuccess, task, plantingId, gardenId, bedId}) {
    const {translate} = useTranslations();
    const [form] = Form.useForm();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const isEditing = !!task;

    useEffect(() => {
        if (open && task) {
            form.setFieldsValue({
                title: task.title,
                description: task.description || '',
                due_at: task.due_at ? dayjs(task.due_at) : null
            });
        }
        if (open && !task) {
            form.resetFields();
        }
    }, [open, task, form]);

    useEffect(() => {
        if (!open) {
            form.resetFields();
        }
    }, [open, form]);

    function handleSubmit() {
        return submitValidatedForm(form, values => {
            setIsSubmitting(true);
            if (isEditing) {
                const taskData = {
                    title: values.title,
                    description: values.description || null,
                    due_at: values.due_at.format('YYYY-MM-DD')
                };
                return api.updateTask(task.id, taskData).then(() => {
                    message.success(translate('Taak bijgewerkt'));
                    onSuccess();
                    onCancel();
                }).catch(() => {
                    message.error(translate('Er ging iets mis'));
                }).finally(() => {
                    setIsSubmitting(false);
                });
            } else {
                const taskData = {
                    title: values.title,
                    description: values.description || null,
                    due_at: values.due_at.format('YYYY-MM-DD'),
                    garden_id: gardenId,
                    bed_id: bedId || null,
                    planting_id: plantingId || null
                };
                return api.createTask(taskData).then(() => {
                    message.success(translate('Taak aangemaakt'));
                    form.resetFields();
                    onSuccess();
                    onCancel();
                }).catch(() => {
                    message.error(translate('Er ging iets mis'));
                }).finally(() => {
                    setIsSubmitting(false);
                });
            }
        });
    }

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            footer={(
                <Button type="primary" onClick={handleSubmit} loading={isSubmitting}>
                    {isEditing ? translate('Opslaan') : translate('Taak aanmaken')}
                </Button>
            )}
        >
            <h1>{isEditing ? translate('Taak bewerken') : translate('Nieuwe taak')}</h1>
            <Form form={form} layout="vertical">
                <Form.Item
                    name="title"
                    label={translate('Titel')}
                    rules={[{required: true, message: translate('Vul een titel in')}]}
                >
                    <Input placeholder={translate('Bijv. Onkruid wieden')}/>
                </Form.Item>
                <Form.Item name="description" label={translate('Beschrijving')}>
                    <TextArea
                        autoSize={{minRows: 2, maxRows: 6}}
                        placeholder={translate('Optionele beschrijving...')}
                    />
                </Form.Item>
                <Form.Item
                    name="due_at"
                    label={translate('Deadline')}
                    rules={[{required: true, message: translate('Selecteer een datum')}]}
                >
                    <DatePicker
                        style={{width: '100%'}}
                        format="DD-MM-YYYY"
                        defaultPickerValue={dayjs()}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
}
